export const TABLE_BILLING_INDEX = {
  BillingID: "billid",
  Status: "status",
  CoName: "coid",
  BillingMonth: "billing_month",
  BillingDate: "billing_date",
  DueDate: "due_date",
  Overdue: "dueDate",
  BillingPeriod: "billing_period",
  BillingAmount: "amount",
  BillingAttachment: "attachment",
  Receipt: "receipt",
  ReceiptRefID: "refid",
  UpdatedAt: "updatedAt",
  CreatedAt: "createdAt",
  Remarks: "remark",
};

export const TABLE_BILLING_TITLE = {
  BillingID: "Billing ID",
  Status: "Status",
  CoName: "Company Name",
  CoID: "Company ID",
  BillingMonth: "Billing Month",
  BillingDate: "Billing Date",
  DueDate: "Due Date",
  Overdue: "Aging Days",
  BillingPeriod: "Billing Period",
  BillingAmount: "Billing Amount",
  BillingAttachment: "Billing Attachment",
  Receipt: "Receipt",
  ReceiptRefID: "Receipt Reference",
  UpdatedAt: "Last Updated By",
  CreatedAt: "Created By",
  Remarks: "Remarks",
};

export const BILLING_STATUS = {
  draft: 1,
  unpaid: 2,
  pendingVerify: 3,
  paid: 4,
  // overdue: 0,
};

export const BILLING_STATUS_TITLE = {
  [BILLING_STATUS.draft]: {
    name: "Draft",
    colorTag: "#959595",
    bgColor: "#F5F5F5",
    status: 1,
  },
  [BILLING_STATUS.unpaid]: {
    name: "Unpaid",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 2,
  },
  [BILLING_STATUS.pendingVerify]: {
    name: "Pending Verify",
    colorTag: "#0E2483",
    bgColor: "#F2F5FF",
    status: 3,
  },
  [BILLING_STATUS.paid]: {
    name: "Paid",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 4,
  },
  // [BILLING_STATUS.overdue]: {
  //   name: "Overdue",
  //   colorTag: "#FF0000",
  //   bgColor: "#FFF2F2",
  //   status: 0,
  // },
};

export const BILLING_INDEX = {};

export const SELECT_OPTIONS = [
  { value: "createdAt", label: "Created Date", type: "date" },
  { value: "billid", label: "Billing ID", type: "text" },
  { value: "coid", label: "Company ID", type: "text" },
  { value: "company_name", label: "Company Name", type: "text" },
  { value: "billingDate", label: "Billing Month", type: "date" },
];
